export const PATH_SEP = ':';
export const ROOT_PATH_SEP = '::';

export function isVaultPath(path) {
  if (path === null || path.length === 0) {
    return false;
  }
  return (
    path === PATH_SEP ||
    (path.charAt(0) === PATH_SEP && path.charAt(1) !== PATH_SEP)
  );
}

export function isPathDescendantOf(path, ancestor) {
  if (path === ancestor) {
    return true;
  }
  if (path.indexOf(ROOT_PATH_SEP) !== ancestor.indexOf(ROOT_PATH_SEP)) {
    return false;
  }
  ancestor = ancestor.substr(-1) === PATH_SEP ? ancestor : ancestor + PATH_SEP;
  return path.indexOf(ancestor) === 0;
}

export function getParentPath(fullPath) {
  // remove any trailing ":" chars from the end of the path
  const path =
    fullPath.lastIndexOf(PATH_SEP) === fullPath.length - 1
      ? fullPath.slice(0, -1)
      : fullPath;
  let parentPath = null;

  if (path === '' || path.lastIndexOf(PATH_SEP) === 1) {
    // we have the parent path already
    parentPath = path;
  } else {
    parentPath = path.slice(0, path.lastIndexOf(PATH_SEP) + 1);
  }
  return parentPath;
}

export function getPathSeparator(isWindows) {
  return isWindows ? '\\' : '/';
}

export function appendToPath(root, toAppend, pathSeparator) {
  if (!root && !toAppend) {
    return '';
  } else if (!root) {
    return toAppend;
  } else if (!toAppend) {
    return root;
  }

  let result = root;
  if (!result.endsWith(pathSeparator) && !toAppend.startsWith(pathSeparator)) {
    result += pathSeparator;
  }
  result += toAppend;
  return result;
}

export function getExtension(fileName) {
  return fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2).toLowerCase();
}

export function fullPathToRelativePath(watchFolder, fullPath) {
  let relPath = null;
  if (watchFolder && watchFolder.path.length <= fullPath.length) {
    relPath = fullPath.substring(watchFolder.path.length);
    relPath = relPath.indexOf(PATH_SEP) === 0 ? relPath.slice(1) : relPath;
    relPath =
      relPath.lastIndexOf(PATH_SEP) === relPath.length - 1
        ? relPath.slice(0, -1)
        : relPath;
  }
  return relPath;
}

export function trimTrailingPathSep(path) {
  if (!path) {
    return path;
  }

  if (path.charAt(path.length - 1) === PATH_SEP) {
    path = path.slice(0, -1);
  }
  return path;
}

export function displayNameFromPath(path) {
  return path
    .split(PATH_SEP)
    .filter(x => !!x)
    .pop();
}

// taken from: http://stackoverflow.com/questions/11100821/javascript-regex-for-validating-filenames#11101624
//  and: https://msdn.microsoft.com/en-us/library/windows/desktop/aa365247(v=vs.85).aspx
const LEGAL_CHARS_REGEX = /^[^\\/:*?"<>|]+$/; // forbidden characters: \ / : * ? " < > |

const ENDS_WITH_DOT_REGEX = /\.$/;

const ENDS_WITH_WHITESPACE_REGEX = /\s$/;

const FORBIDDEN_FILENAMES_REGEX = /^(aux|nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i;

export function isValidFileOrDirectoryName(fileOrDirName) {
  return (
    LEGAL_CHARS_REGEX.test(fileOrDirName) &&
    !ENDS_WITH_DOT_REGEX.test(fileOrDirName) &&
    !FORBIDDEN_FILENAMES_REGEX.test(fileOrDirName) &&
    !ENDS_WITH_WHITESPACE_REGEX.test(fileOrDirName)
  );
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/pathUtils.js